import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithAuth } from './authBase.service'
import { setUserData } from './auth.service';

export const accountApi = createApi({
    reducerPath: 'account',
    baseQuery: baseQueryWithAuth,
    tagTypes: ['UserInfo'],
    refetchOnMountOrArgChange: true, // ✅ Luôn fetch data mới khi reload
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        getUserInfo: builder.query({
            query: () => `/accounts/info`,
            keepUnusedDataFor: 60,
            providesTags: ['UserInfo'],
            transformResponse: (response) => {
                if (response?.success && response?.data) {
                    try {
                        setUserData(response.data);
                    } catch (error) {
                        console.error('Error saving user data to localStorage:', error);
                    }
                }
                return response;
            },
        }),
        updateUserInfo: builder.mutation({
            query: (payload) => ({
                url: `/accounts`,
                method: 'PUT',
                body: payload,
            }),
            invalidatesTags: ['UserInfo'],
        }),
    })
})

export const { useGetUserInfoQuery, useUpdateUserInfoMutation } = accountApi